import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import BlogCard from '../components/BlogCard';
import { blogs } from '../data/blogs';

const BlogIndex = () => {
  return (
    <>
      <SEO
        title="The Lost Boys"
        description="The Lost Boys — stories, essays, and conversations from Broadway Muses."
        path="/journal"
      />

      <div className="mx-auto w-full max-w-7xl px-6 pb-32 pt-36">
        <motion.header
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-20 border-b-8 border-black pb-8"
        >
          <div className="mb-8 flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] font-black uppercase tracking-[0.25em]">
            <span>Broadway Muses / Journal</span>
            <span>Vol. 01 — New York City</span>
          </div>
          <h1 className="w-full px-2 text-center font-serif text-[clamp(2.75rem,10vw,7rem)] font-black uppercase italic leading-none tracking-tight sm:px-6">
            The Lost Boys
          </h1>
          <p className="mt-8 text-center font-mono text-[10px] font-black uppercase tracking-widest">
            Updated{' '}
            <time dateTime="2025-02-21">
              February 21, 2025
            </time>
          </p>
        </motion.header>

        <div className="mb-10 flex items-center justify-between border-b-2 border-black pb-4">
          <h2 className="font-mono text-xs font-black uppercase tracking-[0.3em]">
            Latest dispatches
          </h2>
          <span className="font-mono text-xs font-black uppercase">
            03 stories
          </span>
        </div>

        <section className="grid grid-cols-1 gap-x-8 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
          {blogs.map((blog) => (
            <BlogCard key={blog.slug} blog={blog} />
          ))}
        </section>
      </div>
    </>
  );
};

export default BlogIndex;